import { Box } from '@mui/material';
import { ReactElement, useLayoutEffect, useState } from 'react';
import { Styles } from 'common/types';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import RelativeList from 'common/ui/relative-list';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '../modal/modal';

const styles: Styles = {
  content: {
    p: 0,
    maxWidth: 800,
    mx: 'auto',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 3,
    maxHeight: '85vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  fieldContainer: { width: '100%', m: '0 5px', mt: 2 },
  agreement: {
    textAlign: 'center',
    boxSizing: 'border-box',
  },
  closeButton: {
    position: 'absolute',
    cursor: 'pointer',
    color: 'white',
    right: '24px',
    top: '24px',
  },
};

const Content = styled.div`
  width: 100%;
  height: 600px;
`;

const StyledDocViewer = styled(DocViewer)`
  height: 100%;
`;

type Props = {
  open: boolean;
  onClose: () => void;
  src: string;
  title?: string;
};

export function TermsModal({ open, onClose, src, title }: Props): ReactElement {
  const [wrapperRef, setWrapperRef] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    // remove header from dom, because removing header via component config crash pdf renderer
    setTimeout(() => {
      document.querySelector('#header-bar')?.remove();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handlePreview = () => {
    return <StyledDocViewer pluginRenderers={DocViewerRenderers} documents={[{ uri: src }]} />;
  };
  return (
    <Modal maxWidth="lg" open={open} onClose={onClose} title={title}>
      <Box sx={styles.content}>
        <CloseIcon sx={styles.closeButton} fontSize="medium" onClick={onClose} />
        <Box sx={styles.fieldContainer}>
          <Box sx={styles.agreement}>
            <Content ref={ref => setWrapperRef(ref)}>
              <RelativeList wrapperRef={wrapperRef}>{handlePreview()}</RelativeList>
            </Content>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
